const keyToken: string = 'keyspace/auth';
const keyLineRegisterPathRedirect: string = 'keyspace/lineRegisterPathRedirect';
const keyLineIdRegister: string = 'keyspace/lineIdRegister';
const keyInviteToken: string = 'keyspace/invite';
const keyInviteBrand: string = 'keyspace/brand';
const keyInviteBrandName: string = 'keyspace/brandName';
const keyInviteProject: string = 'keyspace/project';
const keyInviteProjectName: string = 'keyspace/projectName';
const keyInviteZone: string = 'keyspace/zone';
const keyCallbackRedirect: string = 'keyspace/callbackRedirect';
const keyCallbackRedirectFallback: string = 'keyspace/fallback';
const lockerZone: string = 'locker/zone';
const rowsPerPage: string = 'keyspace/page';
const fetchChangeRow: string = 'keyspace/ChangeRow';
const isWinnonie: string = 'winnonie/isBrand';
const winnonieProject: string = 'winnonie/project';
const winnonieStation: string = 'winnonie/station';
const keyInviteUserId: string = 'keyspace/userid';
const keySwitchLogin: string = 'keyspace/typeLogin';
const keyProjectLanguage = 'keyspace/language';
const codeBase: string = 'keyspace/codeBase';
const keyProjectConfigNoOfBookRoomSameTime: string = 'keyspace/noOfBookRoomSameTime';

export const getProjectNoOfBookRoomSameTime = () =>
  localStorage.getItem(keyProjectConfigNoOfBookRoomSameTime);

export const setProjectNoOfBookRoomSameTime = (status: string) =>
  localStorage.setItem(keyProjectConfigNoOfBookRoomSameTime, status);

export const getProjectLanguage = () => localStorage.getItem(keyProjectLanguage);

export const setProjectLanguage = (keyLanguage: string) =>
  localStorage.setItem(keyProjectLanguage, keyLanguage);

export const getKeyLogin = () => {
  return localStorage.getItem(keySwitchLogin);
};

export const setKeyLogin = (statuslogin: string) => {
  localStorage.setItem(keySwitchLogin, statuslogin);
};

export const getToken = () => {
  return localStorage.getItem(keyToken);
};

export const setChangeRow = (ChangeRow: string) => {
  localStorage.setItem(fetchChangeRow, ChangeRow);
};

export const getUserId = () => {
  return localStorage.getItem(keyInviteUserId);
};

export const setUserId = (userID: string) => {
  localStorage.setItem(keyInviteUserId, userID);
};

export const getChangeRow = () => {
  return localStorage.getItem(fetchChangeRow);
};

export const setToken = (token: string) => {
  localStorage.setItem(keyToken, token);
};

export const getLineRegisterPathRedirect = () => {
  return localStorage.getItem(keyLineRegisterPathRedirect);
};

export const setLineRegisterPathRedirect = (LineRegister: string) => {
  localStorage.setItem(keyLineRegisterPathRedirect, LineRegister);
};

export const removeLineRegisterPathRedirect = () => {
  return localStorage.removeItem(keyLineRegisterPathRedirect);
};

export const getLineIdRegister = () => {
  return localStorage.getItem(keyLineIdRegister);
};

export const setLineIdRegister = (LineIdRegister: string) => {
  localStorage.setItem(keyLineIdRegister, LineIdRegister);
};

export const removeLineIdRegister = () => {
  localStorage.removeItem(keyLineIdRegister);
};

export const setLockerZone = (zone: string) => {
  localStorage.setItem(lockerZone, zone);
};
export const getLockerZone = () => {
  return localStorage.getItem(lockerZone);
};

export const clearToken = () => {
  localStorage.removeItem(keyToken);
};

export const getInviteToken = () => {
  return localStorage.getItem(keyInviteToken);
};

export const setInviteToken = (token: string) => {
  localStorage.setItem(keyInviteToken, token);
};

export const clearInviteToken = () => {
  localStorage.removeItem(keyInviteToken);
};

export const getBrand = () => {
  return localStorage.getItem(keyInviteBrand) || '';
};

export const getBrandName = () => {
  return localStorage.getItem(keyInviteBrandName) || '';
};

export const setBrand = (brand: string) => {
  localStorage.setItem(keyInviteBrand, brand);
};
export const setBrandName = (brand: string) => {
  localStorage.setItem(keyInviteBrandName, brand);
};

export const getProject = () => {
  return localStorage.getItem(keyInviteProject) || '';
};

export const getProjectName = () => {
  return localStorage.getItem(keyInviteProjectName) || '';
};

export const setProject = (project: string) => {
  localStorage.setItem(keyInviteProject, project);
};
export const setProjectName = (project: string) => {
  localStorage.setItem(keyInviteProjectName, project);
};

export const getZone = () => {
  return localStorage.getItem(keyInviteZone) || '';
};

export const setZone = (project: string) => {
  localStorage.setItem(keyInviteZone, project);
};

export const clearZone = () => {
  localStorage.removeItem(keyInviteZone);
};

export const clearProject = () => {
  localStorage.removeItem(keyInviteProject);
};

export const getRowsPerPage = () => {
  return localStorage.getItem(rowsPerPage) || '8';
};

export const setRowsPerPage = (page: string) => {
  localStorage.setItem(rowsPerPage, page);
};

export const getCodeBase = () => {
  return localStorage.getItem(codeBase) || 'codeHex';
};

export const setCodeBase = (base: string) => {
  localStorage.setItem(codeBase, base);
};

export const setIsWinnonie = (value: string) => {
  localStorage.setItem(isWinnonie, value);
};

export const getIsWinnonie = () => {
  return localStorage.getItem(isWinnonie);
};

export const clearIsWinnonie = () => {
  localStorage.removeItem(isWinnonie);
};
export const setWinnonieProject = (project: string) => {
  localStorage.setItem(winnonieProject, project);
};

export const getWinnonieProject = () => {
  return localStorage.getItem(winnonieProject) || '';
};

export const clearWinnonieProject = () => {
  localStorage.removeItem(winnonieProject);
};

export const setWinnonieStation = (station: string) => {
  localStorage.setItem(winnonieStation, station);
};

export const getWinnonieStation = () => {
  return localStorage.getItem(winnonieStation) || '';
};

export const clearWinnonieStation = () => {
  localStorage.removeItem(winnonieStation);
};

export const setKeyCallbackRedirect = (value: string) => {
  localStorage.setItem(keyCallbackRedirect, value);
};
export const getKeyCallbackRedirect = () => {
  return localStorage.getItem(keyCallbackRedirect) || '';
};
export const clearKeyCallbackRedirect = () => {
  localStorage.removeItem(keyCallbackRedirect);
};

export const setKeyCallbackRedirectFallback = (value: string) => {
  localStorage.setItem(keyCallbackRedirectFallback, value);
};
export const getKeyCallbackRedirectFallback = () => {
  return localStorage.getItem(keyCallbackRedirectFallback) || '';
};
export const clearKeyCallbackRedirectFallback = () => {
  localStorage.removeItem(keyCallbackRedirectFallback);
};
